import type { ApplySuggestionHandler } from "@/components/Copilot/applySuggestion/applySuggestionHandler"

function getModelId(modelString: string): string {
  return modelString || ""
}

export function makeLLMModelApplyHandler(opts: {
  modelOptions: string[]
  onApply: (value: string) => void
}): ApplySuggestionHandler {
  const options = opts.modelOptions || []
  return async (raw: string) => {
    const val = String(raw ?? "").trim()
    if (!val) return false

    // 1) Exact combined match
    const exact = options.find((m) => m === val)
    if (exact) {
      opts.onApply(exact)
      return true
    }

    // 2) Match by model id directly
    const byId = options.find((m) => getModelId(m) === val)
    if (byId) {
      opts.onApply(byId)
      return true
    }

    // 3) Case-insensitive match
    const lower = val.toLowerCase()
    const byIdLower = options.find((m) => m.toLowerCase() === lower)
    if (byIdLower) {
      opts.onApply(byIdLower)
      return true
    }

    return false
  }
}
